(function(document, window) {
  "use strict";

  if (window.__auxitoSpecialOffersWinnersBound) return;
  window.__auxitoSpecialOffersWinnersBound = true;

  document.addEventListener("click", function(event) {
    var toggle = event.target.closest("[data-so-winners-toggle]");
    if (!toggle) return;

    var root = toggle.closest("[data-so-winners]");
    if (!root) return;

    var cards = root.querySelectorAll("[data-so-winner-card]");
    var initialCount = Math.min(Number(root.dataset.initialCount) || 12, cards.length);
    var expanded = toggle.getAttribute("aria-expanded") !== "true";
    var visibleCount = expanded ? cards.length : initialCount;

    Array.prototype.forEach.call(cards, function(card, index) {
      card.hidden = index >= visibleCount;
    });

    toggle.textContent = expanded
      ? (root.dataset.showLessLabel || "Show Less")
      : (root.dataset.loadMoreLabel || "Load More");
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");

    var status = root.querySelector("[data-so-winners-status]");
    if (status) {
      status.textContent = "Showing " + visibleCount + " of " + cards.length + " winners.";
    }
  });
})(document, window);
